export const initDialogs = () => {
  const dialogs: NodeListOf<HTMLDialogElement> = document.querySelectorAll(".babysits-dialog");

  dialogs.forEach((dialog: HTMLDialogElement) => {
    const closeButtons: NodeListOf<HTMLButtonElement> = dialog.querySelectorAll(".close-dialog");

    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener(
        "click",
        () => {
          dialog.close();

          addClosingBackdrop();
        },
        { passive: true },
      );
    });

    /**
     * Wire backdrop-click-to-close for every dialog at init time so it works
     * regardless of how the dialog is opened (auto, .show-dialog, programmatic).
     * https://stackoverflow.com/questions/25864259/how-to-close-the-new-html-dialog-tag-by-clicking-on-its-backdrop
     */
    dialog.addEventListener(
      "click",
      (event) => {
        /**
         * Select boxes are in firefox positions outside the dialog.
         * Kludge: to prevent the dialog being closed after clicking on a select option inside the dialog, check
         * if the target is selected. If selected, than return.
         */
        const currentDialog = event.target as HTMLSelectElement;

        if (currentDialog.selectedOptions) {
          return;
        }

        if (event.target === dialog) {
          dialog.close();

          addClosingBackdrop();
        }
      },
      { passive: true },
    );

    /* Let's open the dialog automatically if it has the class active */
    if (dialog.classList.contains("active")) {
      dialog.showModal();
    }
  });

  // Search page HTML is loaded dynamically: workaround for auth dialog open-buttons.
  const searchPageDiv = document.getElementById("search") as HTMLDivElement;

  if (searchPageDiv) {
    searchPageDiv.addEventListener(
      "click",
      (e) => {
        const currentDiv = e.target as HTMLDivElement;

        if (!currentDiv.dataset.target || currentDiv.dataset.target !== "dialog-auth") {
          return;
        }

        // Listener may not be passive for this to work on anchor-links
        e.preventDefault();

        const target = currentDiv.dataset.target;
        const dialog = document.getElementById(target) as HTMLDialogElement;

        if (!dialog.open) {
          dialog.showModal();
        }
      },
      { passive: false },
    );
  }

  // Conversation list HTML is loaded dynamically: workaround for auth dialog open-buttons.
  const conversationMessagesWrapper = document.querySelector(
    "#conversation .messages-wrapper",
  ) as HTMLDivElement;

  if (conversationMessagesWrapper) {
    conversationMessagesWrapper.addEventListener(
      "click",
      (e) => {
        const currentWrapper = e.target as HTMLDivElement;

        if (
          !currentWrapper.dataset.target ||
          (currentWrapper.dataset.target !== "dialog-booking-account" &&
            !currentWrapper.dataset.target.startsWith("dialog-addon-time"))
        ) {
          return;
        }

        // Listener may not be passive for this to work on anchor-links
        e.preventDefault();

        const target = currentWrapper.dataset.target;
        const dialog = document.getElementById(target) as HTMLDialogElement;

        if (!dialog.open) {
          dialog.showModal();
        }
      },
      { passive: false },
    );
  }

  const showDialogs: NodeListOf<HTMLLinkElement> = document.querySelectorAll(".show-dialog");

  showDialogs.forEach((showDialog) => {
    showDialog.addEventListener(
      "click",
      () => {
        const target = showDialog.dataset.target as string;
        const dialog = document.getElementById(target) as HTMLDialogElement;

        if (!dialog.open) {
          dialog.showModal();
        }
      },
      { passive: true },
    );
  });

  function addClosingBackdrop() {
    const body = document.querySelector("body") as HTMLBodyElement;

    // Set closing class on backdrop, so it will transition to opacity=0
    const closingBackdrop = document.createElement("div") as HTMLDivElement;

    closingBackdrop.classList.add("closing-backdrop");

    body.append(closingBackdrop);

    setTimeout(() => {
      closingBackdrop.remove();
    }, 400);
  }
};
